import { StartEpisodeWithFlowPayload } from 'APP/Store/History/types'
import { call, select } from 'typed-redux-saga'
import { selectAccessToken } from 'APP/Redux/LoginRedux'
import { selectPatientProfileId } from 'APP/Redux/PatientRedux'
import { navigationRef as Nav } from 'APP/Nav'
import { checkLocationService } from 'APP/NativeModules/PermissionsService'
import Silkroad from 'APP/Services/Silkroad'
import { put } from 'redux-saga/effects'
import PatientHistoryActions from 'APP/Redux/PatientHistoryRedux'
import { fetchNewPostsForChannel } from 'APP/Sagas/PatientHistorySagas/fetchPosts'
import { logger } from 'APP/Lib/Datadog'

export function* startEpisodeWithFlow({
  flowType,
  healthIssueTypeId,
}: StartEpisodeWithFlowPayload) {
  const accessToken = yield* select(selectAccessToken)
  const memberId = yield* select(selectPatientProfileId)

  try {
    const locationPermission = yield* call(checkLocationService)

    if (!memberId) {
      throw new Error('Cannot start episode with flow without a patient profile ID')
    }

    yield* call(Nav.navigate, 'newConversation')

    const silkroad = Silkroad.create(accessToken)
    const episode = yield* call(silkroad.createEpisode, String(memberId), {
      health_issue_type_id: healthIssueTypeId,
    })

    yield* call(silkroad.startFlow, { episodeId: episode.id, flowType })

    yield put(
      PatientHistoryActions.createEpisodeSuccess(episode, undefined, locationPermission, flowType)
    )
    yield* call(Nav.setParams, { channelId: episode.id })
    yield* call(fetchNewPostsForChannel, { channelId: episode.id })
  } catch (err) {
    yield put(PatientHistoryActions.createEpisodeFailure(err))
    logger.debug('startEpisodeWithFlow saga error', { flowType, healthIssueTypeId }, err)
  }
}
